import type { TrackerMessage, TrackerMessageOverview } from '@racemap/sdk/schema/trackers';
import { isMessageNotAcknowledged } from '@racemap/utilities/functions/messages';
import type { Immutable } from 'immer';

export const isMessageNotAcknowledgeEventIfItCouldBe = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): boolean => {
  return isMessageNotAcknowledged(message) && message.shouldAck;
};
